<template>
  <div>
    <v-dialog
      v-model="showDialog"
      persistent
      width="430"
    >
      <v-card>
        <v-card-text class="pt-4">
          <div class="text-xs-center">
            <svg
              style="font-size: 100px;"
              class="icon svg-icon rounded-xl"
              aria-hidden="true"
            >
              <use xlink:href="#iconlogo" />
            </svg>
          </div>
          <div class="my-4 text-body-1 text-xs-center">
            如果您對「巧巧郎」覺得滿意，請給我們一個五星好評吧！
          </div>
          <v-divider class="my-4" />

          <div class="px-4">
            <v-btn
              color="info"
              block
              large
              @click="toStore"
            >
              去評價
            </v-btn>
            <v-btn
              class="mt-3"
              flat
              block
              large
              color="info"
              @click="showDialog=false"
            >
              <u>殘忍拒絕</u>
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  data () {
    return {
      showDialog: false,
    }
  },
  methods: {
    open () {
      if (!localStorage.AppScoreDialogShowed) {
        this.showDialog = true
      }
    },
    toStore () {
      window.open('https://chrome.google.com/webstore/detail/%E5%B7%A7%E5%B7%A7%E9%83%8E%E7%9A%84%E9%91%B0%E5%8C%99/lacejchmbljdoaimkbmcflcechgndbim/reviews')
      this.showDialog = false
      localStorage.AppScoreDialogShowed = '1'
    },
  }
}
</script>
